<template>
  <div class="menu-item-group work-sidebar-nav" v-if="canWork">
    <!-- Header Sectiune Meniu -->
    <div class="menu-item pt-5">
      <div class="menu-content pb-2">
        <span class="menu-heading fw-bold text-uppercase fs-7 text-danger d-flex align-items-center">
          <i class="fa-solid fa-briefcase text-danger me-2 fs-6"></i>
          Lucrează Firme
        </span>
      </div>
    </div>

    <!-- Widget Firmă Selectată / Selector -->
    <div class="menu-item px-3 mb-1">
      <!-- Cazul 1: Firmă selectată - compact, fără logo -->
      <div v-if="workStore.hasFirma" class="p-2 px-3 rounded bg-light border border-gray-300 d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column min-w-0 me-2" style="max-width: 140px;">
          <span class="text-dark fw-bold fs-8 text-truncate" :title="workStore.firmaDenumire">
            {{ workStore.firmaDenumire }}
          </span>
          <span class="text-muted fs-9" v-if="workStore.firmaCui">CUI: {{ workStore.firmaCui }}</span>
        </div>
        <div class="d-flex align-items-center gap-1">
          <router-link to="/administrare/work" class="btn btn-icon btn-xs btn-light-primary" title="Caută / Schimbă firma">
            <i class="fa-solid fa-arrows-rotate fs-8"></i>
          </router-link>
          <button type="button" class="btn btn-icon btn-xs btn-light-danger" @click="resetFirma" title="Resetează selecția">
            <i class="fa-solid fa-xmark fs-8"></i>
          </button>
        </div>
      </div>

      <!-- Cazul 2: Fără firmă selectată - router-link direct către /administrare/work -->
      <div v-else>
        <router-link to="/administrare/work" class="btn btn-sm btn-light-danger w-100 text-start py-2 px-3 d-flex align-items-center justify-content-between">
          <span class="d-flex align-items-center fs-7 fw-semibold">
            <i class="fa-solid fa-magnifying-glass me-2 fs-7"></i>
            Selectează firma
          </span>
          <i class="fa-solid fa-chevron-right fs-9 opacity-50"></i>
        </router-link>
      </div>
    </div>

    <!-- MODULE ȘI SUBMENIURI (AFIȘATE DOAR DACĂ ESTE SELECTATĂ O FIRMĂ) -->
    <template v-if="workStore.hasFirma">
      <!-- 1. FACTURARE -->
      <div class="menu-item menu-accordion" :class="{ 'hover show': isAccordionActive('facturare') }" data-kt-menu-sub="accordion">
      <span class="menu-link" @click="toggleAccordion('facturare')">
        <span class="menu-icon">
          <i class="fa-solid fa-file-invoice-dollar text-primary fs-3"></i>
        </span>
        <span class="menu-title">Facturare</span>
        <span class="menu-arrow"></span>
      </span>
      <div class="menu-sub menu-sub-accordion" :class="{ 'show': isAccordionOpen('facturare') }">
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('facturare', 'emise') }" @click.prevent="goToSub('facturare', 'emise')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Facturi emise</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('facturare', 'primite') }" @click.prevent="goToSub('facturare', 'primite')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Facturi primite</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('facturare', 'extrase') }" @click.prevent="goToSub('facturare', 'extrase')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Extrase bancare</span>
          </a>
        </div>
      </div>
    </div>

    <!-- 2. CONTABILITATE -->
    <div class="menu-item menu-accordion" :class="{ 'hover show': isAccordionActive('contabilitate') }" data-kt-menu-sub="accordion">
      <span class="menu-link" @click="toggleAccordion('contabilitate')">
        <span class="menu-icon">
          <i class="fa-solid fa-calculator text-success fs-3"></i>
        </span>
        <span class="menu-title">Contabilitate</span>
        <span class="menu-arrow"></span>
      </span>
      <div class="menu-sub menu-sub-accordion" :class="{ 'show': isAccordionOpen('contabilitate') }">
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'registru_jurnal') }" @click.prevent="goToSub('contabilitate', 'registru_jurnal')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">{{ workStore.isPfa ? 'Registru Încasări & Plăți' : 'Registru Jurnal' }}</span>
          </a>
        </div>
        <div class="menu-item" v-if="!workStore.isPfa">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'balanta') }" @click.prevent="goToSub('contabilitate', 'balanta')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Balanță</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'jurnal_tva') }" @click.prevent="goToSub('contabilitate', 'jurnal_tva')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Jurnal cumpărări & vânzări</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'fisa_cont') }" @click.prevent="goToSub('contabilitate', 'fisa_cont')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Fișă Cont</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'declaratii_anaf') }" @click.prevent="goToSub('contabilitate', 'declaratii_anaf')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Declarații ANAF</span>
          </a>
        </div>
        <div class="menu-item" v-if="!workStore.isPfa">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'nomenclator_produse') }" @click.prevent="goToSub('contabilitate', 'nomenclator_produse')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Produse</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('contabilitate', 'plan_conturi') }" @click.prevent="goToSub('contabilitate', 'plan_conturi')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Plan de conturi</span>
          </a>
        </div>
      </div>
    </div>

    <!-- 3. ANGAJAȚI -->
    <div class="menu-item menu-accordion" :class="{ 'hover show': isAccordionActive('angajati') }" data-kt-menu-sub="accordion">
      <span class="menu-link" @click="toggleAccordion('angajati')">
        <span class="menu-icon">
          <i class="fa-solid fa-users text-warning fs-3"></i>
        </span>
        <span class="menu-title">Angajați</span>
        <span class="menu-arrow"></span>
      </span>
      <div class="menu-sub menu-sub-accordion" :class="{ 'show': isAccordionOpen('angajati') }">
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('angajati', 'contracte') }" @click.prevent="goToSub('angajati', 'contracte')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Contracte</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('angajati', 'state') }" @click.prevent="goToSub('angajati', 'state')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">State de plată</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('angajati', 'pontaje') }" @click.prevent="goToSub('angajati', 'pontaje')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Pontaje</span>
          </a>
        </div>
      </div>
    </div>

    <!-- 4. FIȘIERE -->
    <div class="menu-item menu-accordion" :class="{ 'hover show': isAccordionActive('fisiere') }" data-kt-menu-sub="accordion">
      <span class="menu-link" @click="toggleAccordion('fisiere')">
        <span class="menu-icon">
          <i class="fa-solid fa-folder-open text-info fs-3"></i>
        </span>
        <span class="menu-title">Fișiere</span>
        <span class="menu-arrow"></span>
      </span>
      <div class="menu-sub menu-sub-accordion" :class="{ 'show': isAccordionOpen('fisiere') }">
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'iesiri') }" @click.prevent="goToSub('fisiere', 'iesiri')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Ieșiri</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'intrari') }" @click.prevent="goToSub('fisiere', 'intrari')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Intrări</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'extrase') }" @click.prevent="goToSub('fisiere', 'extrase')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Extrase</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'altedocumente') }" @click.prevent="goToSub('fisiere', 'altedocumente')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Alte doc.</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'tot') }" @click.prevent="goToSub('fisiere', 'tot')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Tot</span>
          </a>
        </div>
        <div class="menu-item">
          <a href="#" class="menu-link" :class="{ 'active': isSubActive('fisiere', 'status_luni') }" @click.prevent="goToSub('fisiere', 'status_luni')">
            <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
            <span class="menu-title">Gestiune luni</span>
          </a>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import { useWorkFirmStore } from '../../../stores/workFirmStore';
import { useUserStore } from '../../../stores/user';

export default {
  name: 'WorkSidebarMenu',
  setup() {
    const workStore = useWorkFirmStore();
    const userStore = useUserStore();
    return { workStore, userStore };
  },
  data() {
    return {
      openAccordions: {
        facturare: false,
        contabilitate: false,
        angajati: false,
        fisiere: false,
      }
    };
  },
  computed: {
    canWork() {
      const mode = this.userStore.currentSidebarMode || 'tot';
      if (mode === 'client') return false;

      if (this.$gate && typeof this.$gate.canWorkOnFirms === 'function') {
        return this.$gate.canWorkOnFirms();
      }
      return this.$gate?.isAdmin() || false;
    }
  },
  created() {
    this.workStore.loadFromStorage();
    this.syncAccordionFromRoute();
  },
  watch: {
    '$route.path'() {
      this.syncAccordionFromRoute();
    }
  },
  methods: {
    syncAccordionFromRoute() {
      const module = this.$route?.params?.module;
      if (module && this.openAccordions[module] !== undefined) {
        this.openAccordions[module] = true;
      }
    },
    toggleAccordion(key) {
      this.openAccordions[key] = !this.openAccordions[key];
    },
    isAccordionOpen(key) {
      return !!this.openAccordions[key] || this.isAccordionActive(key);
    },
    isAccordionActive(module) {
      return this.$route?.params?.module === module && this.$route?.path?.startsWith('/administrare/work');
    },
    isSubActive(module, submodule) {
      if (!this.$route?.path?.startsWith('/administrare/work')) return false;
      const currentMod = this.$route?.params?.module;
      let currentSub = this.$route?.params?.submodule;
      if (currentSub === 'facturi_emise') currentSub = 'emise';
      if (currentSub === 'facturi_primite') currentSub = 'primite';
      return currentMod === module && currentSub === submodule;
    },
    goToSub(module, submodule) {
      if (!this.workStore.hasFirma) {
        // Redirecționează către pagina de căutare / administrare work
        this.workStore.openSelectModal({ module, submodule });
        return;
      }

      const targetPath = `/administrare/work/${this.workStore.firmaId}/${module}/${submodule}`;
      if (this.$route?.path !== targetPath) {
        this.$router.push(targetPath).catch(() => {});
      }
    },
    goToSearchPage() {
      if (this.$route?.path !== '/administrare/work') {
        this.$router.push('/administrare/work').catch(() => {});
      }
    },
    openFirmModal(target = null) {
      this.workStore.openSelectModal(target);
    },
    resetFirma() {
      this.workStore.clearFirma();
      if (this.$route?.path?.startsWith('/administrare/work')) {
        this.$router.push('/administrare/work').catch(() => {});
      }
    }
  }
};
</script>

<style scoped>
.active-firm-card {
  transition: all 0.2s ease;
}
.btn-xs {
  font-size: 0.72rem;
  padding: 0.2rem 0.45rem;
}
.fs-9 {
  font-size: 0.65rem;
}
</style>
